import { useEffect, useState } from "react";
import { TagSelector } from "../TagSelector/TagSelector";
import { isDiff } from "../../utils/array";
import { compareEntityArrays } from "../../utils/entity";
import TagList from "../TagList/TagList";
import Button from "../Button/Button";

export function TagSelectorBox({
   tags,
   onTagsChange,
   isOpen,
   onClose,
   type,
   customFilter,
   action,
}) {
   const [isLoading, setIsLoading] = useState(true);
   const [showTagModal, setShowTagModal] = useState(false);
   const [localTags, setLocalTags] = useState(tags);
   const [tagsData, setTagsData] = useState([]);

   useEffect(() => {
      if (!compareEntityArrays(tags, localTags)) {
         setLocalTags(tags);
      }
   }, [tags]);

   useEffect(() => {
      setShowTagModal(isOpen);
   }, [isOpen]);

   function handleOnClose() {
      setShowTagModal(false);
      onClose?.();
   }

   function onTagsLoaded(tags) {
      setIsLoading(false);
      setTagsData(tags);
   }

   function handleOnTagsChange(updatedTags) {
      const prevTagsIds = localTags?.map(Number) ?? [];
      const tagsIds = updatedTags.map(t => Number(typeof t === 'object' ? t.id : t));

      if (isDiff(prevTagsIds, tagsIds)) {
         setLocalTags(tagsIds);
         onTagsChange(tagsIds);
      }
   }

   function handleRemoveTag(id) {
      const newList = [...localTags];
      const index = newList.findIndex(tag => Number(id) === Number(typeof tag === 'object' ? tag.id : tag));
      if (index === -1) return;
      newList.splice(index, 1);
      handleOnTagsChange(newList);
   }

   const selectedTagsData = tagsData?.filter(tagData => tags?.some(tagId => Number(tagId) === Number(tagData.id)));

   return (
      <>
         <div className="tags-container" style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
               <h4 className="input-label" style={{ marginBottom: 0 }}>Etiquetas</h4>
               <div className="container-buttons" style={{ width: '100%', flexDirection: 'row', justifyContent: 'end', marginTop: 0 }}>
                  {action !== "consulta" && (
                     <Button
                        label="Adicionar"
                        action="add"
                        onClick={() => setShowTagModal(true)}
                        className="button-link"
                        style={{ padding: '5px 10px', fontSize: '12px' }}
                     />
                  )}
               </div>
            </div>
            <TagList
               tags={selectedTagsData ?? []}
               onRemove={(idx) => handleRemoveTag(selectedTagsData?.[idx]?.id)}
               disabled={action === "consulta"}
            />
         </div>
         <TagSelector
            tags={tags ?? []}
            type={type}
            customFilter={customFilter}
            isOpen={showTagModal}
            onLoad={onTagsLoaded}
            onClose={handleOnClose}
            onTagsChange={handleOnTagsChange} />
      </>
   );
}